module.exports = __webpack_public_path__ + "img/2-Circle.80f6013.png";